import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponse, ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import {UserCatalogContainerModel} from '../../../../../../models/aggregates/applet';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UserCatalogLinksService extends BaseApiTemplateService<any> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'catalog-login-subject-links';
    this.httpClient = http;
  }

  onInstall(dtoObject: UserCatalogContainerModel, apiVisa: ApiVisa): Observable<ApiResponseModel<UserCatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/install';
    }
    return this.httpClient.post<ApiResponseModel<UserCatalogContainerModel>>(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa));
  }

  onUninstall(guid: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/uninstall/' + guid;
    }
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  onAdminInstall(userAppletContainer: UserCatalogContainerModel, apiVisa: ApiVisa): Observable<ApiResponseModel<UserCatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/admin/install';
    }
    return this.httpClient.post<ApiResponseModel<UserCatalogContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }

  onMultipleAdminInstall(userAppletContainer: UserCatalogContainerModel[], apiVisa: ApiVisa): Observable<ApiResponseModel<UserCatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/admin/multiple-install';
    }
    return this.httpClient.post<ApiResponseModel<UserCatalogContainerModel>>(this.apiUrl, userAppletContainer, this.getHttpHeader(apiVisa));
  }

  onSysadminInstall(userCatalogContainer: UserCatalogContainerModel, apiVisa): Observable<ApiResponseModel<UserCatalogContainerModel>>{
    if (this.endpoint_path && apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/install';
    }
    return this.httpClient.post<ApiResponseModel<UserCatalogContainerModel>>(this.apiUrl, userCatalogContainer, this.getHttpHeader(apiVisa));
  }
  
  getUserInstalledApplets(apiVisa: ApiVisa, hostnameValueL: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '?hostname_value=' + hostnameValueL;
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  // /core2/platform/dm/catalog-login-subject-links/multiple-delete/{tenantCode}/sysadmin-ep
  deleteMultipleBySysAdminEp(
    dto: any,
    tenantCode: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const endpointPath = `${Core2Config.PLATFORM_URL_PREFIX}${Core2Config.DOMAIN_PREFIX}catalog-login-subject-links/multiple-delete/${tenantCode}/sysadmin-ep`;
    const apiUrl = visa.api_domain_url + endpointPath;

    return this.httpClient.post<ApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }


}


